import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getFocusAccordion, focusAnimation } from "../../../src/action/buildProduct";

function AnimateFocusAccordionOverlay(props) {
  const {
    app,
    buildProduct,
    cart,
    lqState,
  } = props;
  const [focusAccordion, setFocusAccordion] = useState("");

  useEffect(() => {
    try {
      if (
        buildProduct?.internet?.selectedProduct
        || (buildProduct?.router?.selectedProduct && buildProduct?.router?.equipments)
        || ((buildProduct?.sploffer?.selectedProduct || buildProduct?.sploffer?.data?.selectedProduct) && (buildProduct?.sploffer?.data?.offerplans2YR || buildProduct?.sploffer?.data?.offerplansMTM))
        || (buildProduct?.flashoffer?.selectedProduct && (buildProduct?.flashoffer?.offerplans2YR || buildProduct?.flashoffer?.offerplansMTM))
        || (buildProduct?.perks?.selectedProduct && buildProduct?.perks?.plans)
      ) {
        const focusType = getFocusAccordion("internet", app?.flowType, buildProduct, cart, lqState, null);
        if (focusType && focusType !== focusAccordion) {
          setFocusAccordion(focusType);
        }
      }
    } catch (e) {
      console.error(e);
    }
  }, [
    buildProduct?.internet?.selectedProduct,
    buildProduct?.router?.selectedProduct,
    buildProduct?.sploffer?.selectedProduct,
    buildProduct?.sploffer?.data?.selectedProduct,
    buildProduct?.flashoffer?.selectedProduct,
    buildProduct?.perks?.selectedProduct,
    buildProduct?.router?.equipments,
    buildProduct?.sploffer?.data?.offerplans2YR,
    buildProduct?.sploffer?.data?.offerplansMTM,
    buildProduct?.flashoffer?.offerplans2YR,
    buildProduct?.flashoffer?.offerplansMTM,
    buildProduct?.perks?.plans,
  ]);

  useEffect(() => {
    if (
      buildProduct?.internet?.isSubAccordionOpen
      || buildProduct?.router?.isAccordionOpen
      || buildProduct?.sploffer?.isAccordionOpen
      || buildProduct?.sploffer?.data?.isAccordionOpen
      || buildProduct?.flashoffer?.isAccordionOpen
      || buildProduct?.flashoffer?.isSubAccordionOpen
      || buildProduct?.perks?.isAccordionOpen
      || buildProduct?.perks?.isSubAccordionOpen
    )
      if (focusAccordion) {
        let accordionElement = document.getElementById(focusAccordion);
        if (accordionElement) {
          if(focusAccordion !== "toggle_data_splOffer_accor"){
            setTimeout(() => {
              accordionElement = document.getElementById(focusAccordion);
              focusAnimation(accordionElement?.offsetTop);
            },1000)
          }
          else {
            accordionElement = document.getElementById(focusAccordion);
            focusAnimation(accordionElement?.offsetTop);
          }
            setFocusAccordion("")
          }
          
      }
  }, [
    focusAccordion,
    buildProduct?.internet?.isSubAccordionOpen,
    buildProduct?.router?.isAccordionOpen,
    buildProduct?.sploffer?.isAccordionOpen,
    buildProduct?.sploffer?.data?.isAccordionOpen,
    buildProduct?.flashoffer?.isAccordionOpen,
    buildProduct?.flashoffer?.isSubAccordionOpen,
    buildProduct?.perks?.isAccordionOpen,
    buildProduct?.perks?.isSubAccordionOpen,
  ]);

  return (
    <>
      {props?.children}
    </>
  );
}

const mapStateToProps = (state) => ({
  app: state?.app,
  buildProduct: state?.buildProduct,
  cart: state?.cart,
  lqState: state?.loopQual,
});

export default connect(mapStateToProps)(AnimateFocusAccordionOverlay);